// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickJournalNightLakeShips__container___JKgDt {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
}

.QuickJournalNightLakeShips__horizon___PzKc0 {
    position: absolute;
    top: 1px;
    left: 0;
    right: 0;
    height: 38px;
    opacity: 0.72;
}

.QuickJournalNightLakeShips__horizonShip___DvEHi {
    position: absolute;
    top: -6px;
    left: -10%;
    width: 46px;
    height: 18px;
    opacity: 0.5;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-composition: add;
}

.QuickJournalNightLakeShips__horizonShipOne____9jzK {
    width: 42px;
    animation-name: QuickJournalNightLakeShips__quickJournalNightHorizonShipDrift___EC7oS;
    animation-duration: 124s;
    animation-delay: -28s;
    animation-name:
        QuickJournalNightLakeShips__quickJournalNightHorizonShipDrift___EC7oS,
        QuickJournalNightLakeShips__quickJournalNightShipCenterFade___p9uFv;
    animation-duration: 124s, 124s;
    animation-delay: -28s, -28s;
}

.QuickJournalNightLakeShips__horizonShipTwo___YzfxO {
    top: 1px;
    width: 34px;
    opacity: 0.36;
    animation-name: QuickJournalNightLakeShips__quickJournalNightHorizonShipDrift___EC7oS;
    animation-duration: 148s;
    animation-delay: -91s;
    animation-name:
        QuickJournalNightLakeShips__quickJournalNightHorizonShipDrift___EC7oS,
        QuickJournalNightLakeShips__quickJournalNightShipCenterFade___p9uFv;
    animation-duration: 148s, 148s;
    animation-delay: -91s, -91s;
}

.QuickJournalNightLakeShips__horizonShipInner___Dmwev {
    position: relative;
    width: 100%;
    height: 100%;
    animation: QuickJournalNightLakeShips__quickJournalNightHorizonShipBob___M3Q8l 11s ease-in-out infinite;
}

.QuickJournalNightLakeShips__horizonShipTwo___YzfxO .QuickJournalNightLakeShips__horizonShipInner___Dmwev {
    animation-duration: 13s;
    animation-delay: -4.4s;
}

.QuickJournalNightLakeShips__horizonHull___H6Xgl {
    position: absolute;
    left: 8%;
    right: 2%;
    top: 4px;
    height: 5px;
    border-radius: 0 0 999px 999px;
    background: rgba(1, 5, 13, 0.82);
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.38);
    clip-path: polygon(0 34%, 78% 34%, 100% 0, 86% 100%, 12% 100%);
}

.QuickJournalNightLakeShips__horizonLight___f34yE {
    position: absolute;
    left: 54%;
    top: 2px;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background: rgba(255, 205, 118, 0.68);
    box-shadow: 0 0 5px rgba(255, 184, 88, 0.34);
    animation: QuickJournalNightLakeShips__quickJournalNightShipLight___PjLhk 6.4s ease-in-out infinite;
}

.QuickJournalNightLakeShips__horizonReflection___vn_81 {
    position: absolute;
    left: 20%;
    right: 6%;
    top: 12px;
    height: 6px;
    border-radius: 50%;
    background:
        radial-gradient(
            ellipse at 50% 50%,
            rgba(255, 196, 112, 0.08) 0%,
            rgba(102, 132, 184, 0.06) 36%,
            rgba(102, 132, 184, 0) 78%
        );
    filter: blur(2px);
    transform: scaleX(1.4);
}

.QuickJournalNightLakeShips__shoreLight___SQWD8 {
    position: absolute;
    left: 50%;
    top: 0;
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: rgba(255, 205, 118, 0.34);
    box-shadow:
        0 0 6px rgba(255, 206, 130, 0.24),
        0 0 14px rgba(122, 153, 216, 0.1);
    filter: blur(0.7px);
    transform: translateX(-50%);
    animation: QuickJournalNightLakeShips__quickJournalNightShoreLight___HVxJh 8s ease-in-out infinite;
}

.QuickJournalNightLakeShips__shoreGlow___JS2on {
    position: absolute;
    top: -2px;
    width: 22px;
    height: 24px;
    transform: translateX(-50%);
}

.QuickJournalNightLakeShips__shoreGlowOne___qheVc {
    left: 16%;
}

.QuickJournalNightLakeShips__shoreGlowTwo___dIi_l {
    left: 31%;
    opacity: 0.72;
}

.QuickJournalNightLakeShips__shoreGlowThree___RJuyr {
    left: 84%;
    opacity: 0.5;
}

.QuickJournalNightLakeShips__shoreGlowOne___qheVc .QuickJournalNightLakeShips__shoreLight___SQWD8 {
    animation-delay: -2s;
}

.QuickJournalNightLakeShips__shoreGlowTwo___dIi_l .QuickJournalNightLakeShips__shoreLight___SQWD8 {
    animation-delay: -5.6s;
}

.QuickJournalNightLakeShips__shoreGlowThree___RJuyr .QuickJournalNightLakeShips__shoreLight___SQWD8 {
    animation-delay: -3.8s;
}

.QuickJournalNightLakeShips__shoreReflection___eluWS {
    position: absolute;
    left: 50%;
    top: 6px;
    width: 18px;
    height: 15px;
    border-radius: 50%;
    background:
        radial-gradient(
            ellipse at 50% 0%,
            rgba(255, 205, 118, 0.1) 0%,
            rgba(111, 143, 204, 0.07) 28%,
            rgba(111, 143, 204, 0.035) 54%,
            rgba(111, 143, 204, 0) 82%
        );
    filter: blur(3.5px);
    transform: translateX(-50%) scaleX(0.68);
    animation: QuickJournalNightLakeShips__quickJournalNightShoreReflection___oHTtp 10s ease-in-out infinite;
}

.QuickJournalNightLakeShips__shoreGlowTwo___dIi_l .QuickJournalNightLakeShips__shoreReflection___eluWS {
    animation-delay: -4.7s;
}

.QuickJournalNightLakeShips__shoreGlowThree___RJuyr .QuickJournalNightLakeShips__shoreReflection___eluWS {
    animation-delay: -7.2s;
}

.QuickJournalNightLakeShips__ship___pISeb {
    position: absolute;
    top: 28%;
    left: -16%;
    width: 74px;
    height: 28px;
    opacity: 0.42;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-composition: add;
}

.QuickJournalNightLakeShips__shipOne___PJp69 {
    top: 24%;
    width: 68px;
    opacity: 0.38;
    animation-name: QuickJournalNightLakeShips__quickJournalNightShipDrift___hF5pa;
    animation-duration: 86s;
    animation-name: QuickJournalNightLakeShips__quickJournalNightShipDrift___hF5pa, QuickJournalNightLakeShips__quickJournalNightShipCenterFade___p9uFv;
    animation-duration: 86s, 86s;
}

.QuickJournalNightLakeShips__shipTwo___w8GDC {
    top: 34%;
    width: 54px;
    opacity: 0.3;
    animation-name: QuickJournalNightLakeShips__quickJournalNightShipDrift___hF5pa;
    animation-duration: 112s;
    animation-delay: -42s;
    animation-name: QuickJournalNightLakeShips__quickJournalNightShipDrift___hF5pa, QuickJournalNightLakeShips__quickJournalNightShipCenterFade___p9uFv;
    animation-duration: 112s, 112s;
    animation-delay: -42s, -42s;
}

.QuickJournalNightLakeShips__shipThree___UEyHM {
    top: 18%;
    width: 82px;
    opacity: 0.26;
    animation-name: QuickJournalNightLakeShips__quickJournalNightShipDrift___hF5pa;
    animation-duration: 98s;
    animation-delay: -71s;
    animation-name: QuickJournalNightLakeShips__quickJournalNightShipDrift___hF5pa, QuickJournalNightLakeShips__quickJournalNightShipCenterFade___p9uFv;
    animation-duration: 98s, 98s;
    animation-delay: -71s, -71s;
}

.QuickJournalNightLakeShips__shipInner____PrCD {
    position: relative;
    width: 100%;
    height: 100%;
    animation: QuickJournalNightLakeShips__quickJournalNightShipBob___Gi9pD 8.4s ease-in-out infinite;
}

.QuickJournalNightLakeShips__shipTwo___w8GDC .QuickJournalNightLakeShips__shipInner____PrCD {
    animation-duration: 9.8s;
    animation-delay: -3.2s;
}

.QuickJournalNightLakeShips__shipThree___UEyHM .QuickJournalNightLakeShips__shipInner____PrCD {
    animation-duration: 7.6s;
    animation-delay: -5.8s;
}

.QuickJournalNightLakeShips__hull___xQwJ7 {
    position: absolute;
    left: 10%;
    right: 6%;
    bottom: 10px;
    height: 9px;
    border-radius: 0 0 999px 999px;
    background:
        linear-gradient(
            to bottom,
            rgba(8, 14, 25, 0.92) 0%,
            rgba(1, 5, 12, 0.96) 100%
        );
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.5);
    clip-path: polygon(0 20%, 72% 20%, 100% 0, 88% 100%, 12% 100%);
}

.QuickJournalNightLakeShips__cabin___wAPDF {
    position: absolute;
    left: 42%;
    bottom: 18px;
    width: 22%;
    height: 8px;
    border-radius: 2px 2px 0 0;
    background: rgba(5, 10, 18, 0.82);
}

.QuickJournalNightLakeShips__light___cZVj5 {
    position: absolute;
    top: 3px;
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: rgba(255, 205, 118, 0.78);
    box-shadow: 0 0 6px rgba(255, 184, 88, 0.44);
    animation: QuickJournalNightLakeShips__quickJournalNightShipLight___PjLhk 5.4s ease-in-out infinite;
}

.QuickJournalNightLakeShips__lightOne___FGQim {
    left: 18%;
}

.QuickJournalNightLakeShips__lightTwo___arYmD {
    left: 47%;
    animation-delay: -1.7s;
}

.QuickJournalNightLakeShips__lightThree___U54zL {
    left: 73%;
    opacity: 0.58;
    animation-delay: -3.1s;
}

.QuickJournalNightLakeShips__reflection___wEah8 {
    position: absolute;
    left: 8%;
    right: 2%;
    bottom: 0;
    height: 7px;
    border-radius: 50%;
    background:
        radial-gradient(
            ellipse at 50% 50%,
            rgba(255, 196, 112, 0.15) 0%,
            rgba(118, 148, 194, 0.08) 32%,
            rgba(118, 148, 194, 0) 76%
        );
    filter: blur(3px);
    transform: scaleX(1.24);
}

@keyframes QuickJournalNightLakeShips__quickJournalNightShipDrift___hF5pa {
    0% {
        transform: translate3d(-12vw, 0, 0);
    }

    100% {
        transform: translate3d(126vw, 0, 0);
    }
}

@keyframes QuickJournalNightLakeShips__quickJournalNightHorizonShipDrift___EC7oS {
    0% {
        transform: translate3d(-8vw, 0, 0);
    }

    100% {
        transform: translate3d(118vw, 0, 0);
    }
}

@keyframes QuickJournalNightLakeShips__quickJournalNightShipCenterFade___p9uFv {
    0%,
    38%,
    62%,
    100% {
        opacity: 1;
    }

    45%,
    55% {
        opacity: 0;
    }
}

@keyframes QuickJournalNightLakeShips__quickJournalNightShipBob___Gi9pD {
    0%,
    100% {
        transform: translate3d(0, 0, 0) rotate(-0.4deg);
    }

    50% {
        transform: translate3d(0, 2px, 0) rotate(0.5deg);
    }
}

@keyframes QuickJournalNightLakeShips__quickJournalNightHorizonShipBob___M3Q8l {
    0%,
    100% {
        transform: translate3d(0, 0, 0) rotate(-0.25deg);
    }

    50% {
        transform: translate3d(0, 1px, 0) rotate(0.3deg);
    }
}

@keyframes QuickJournalNightLakeShips__quickJournalNightShipLight___PjLhk {
    0%,
    100% {
        opacity: 0.58;
    }

    50% {
        opacity: 0.9;
    }
}

@keyframes QuickJournalNightLakeShips__quickJournalNightShoreLight___HVxJh {
    0%,
    18%,
    100% {
        opacity: 0.18;
        transform: translateX(-50%) scale(0.72);
    }

    24%,
    30% {
        opacity: 0.86;
        transform: translateX(-50%) scale(1.18);
    }

    34%,
    58% {
        opacity: 0.32;
        transform: translateX(-50%) scale(0.9);
    }

    64%,
    70% {
        opacity: 0.72;
        transform: translateX(-50%) scale(1.08);
    }
}

@keyframes QuickJournalNightLakeShips__quickJournalNightShoreReflection___oHTtp {
    0%,
    100% {
        opacity: 0.18;
        transform: translateX(-50%) scale(0.46, 0.72);
    }

    28% {
        opacity: 0.62;
        transform: translateX(-50%) scale(0.82, 1.08);
    }

    58% {
        opacity: 0.28;
        transform: translateX(-50%) scale(0.62, 0.86);
    }

    68% {
        opacity: 0.5;
        transform: translateX(-50%) scale(0.76, 1);
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuickJournalNightLakeShips__container___JKgDt`,
	"horizon": `QuickJournalNightLakeShips__horizon___PzKc0`,
	"horizonShip": `QuickJournalNightLakeShips__horizonShip___DvEHi`,
	"horizonShipOne": `QuickJournalNightLakeShips__horizonShipOne____9jzK`,
	"quickJournalNightHorizonShipDrift": `QuickJournalNightLakeShips__quickJournalNightHorizonShipDrift___EC7oS`,
	"quickJournalNightShipCenterFade": `QuickJournalNightLakeShips__quickJournalNightShipCenterFade___p9uFv`,
	"horizonShipTwo": `QuickJournalNightLakeShips__horizonShipTwo___YzfxO`,
	"horizonShipInner": `QuickJournalNightLakeShips__horizonShipInner___Dmwev`,
	"quickJournalNightHorizonShipBob": `QuickJournalNightLakeShips__quickJournalNightHorizonShipBob___M3Q8l`,
	"horizonHull": `QuickJournalNightLakeShips__horizonHull___H6Xgl`,
	"horizonLight": `QuickJournalNightLakeShips__horizonLight___f34yE`,
	"quickJournalNightShipLight": `QuickJournalNightLakeShips__quickJournalNightShipLight___PjLhk`,
	"horizonReflection": `QuickJournalNightLakeShips__horizonReflection___vn_81`,
	"shoreLight": `QuickJournalNightLakeShips__shoreLight___SQWD8`,
	"quickJournalNightShoreLight": `QuickJournalNightLakeShips__quickJournalNightShoreLight___HVxJh`,
	"shoreGlow": `QuickJournalNightLakeShips__shoreGlow___JS2on`,
	"shoreGlowOne": `QuickJournalNightLakeShips__shoreGlowOne___qheVc`,
	"shoreGlowTwo": `QuickJournalNightLakeShips__shoreGlowTwo___dIi_l`,
	"shoreGlowThree": `QuickJournalNightLakeShips__shoreGlowThree___RJuyr`,
	"shoreReflection": `QuickJournalNightLakeShips__shoreReflection___eluWS`,
	"quickJournalNightShoreReflection": `QuickJournalNightLakeShips__quickJournalNightShoreReflection___oHTtp`,
	"ship": `QuickJournalNightLakeShips__ship___pISeb`,
	"shipOne": `QuickJournalNightLakeShips__shipOne___PJp69`,
	"quickJournalNightShipDrift": `QuickJournalNightLakeShips__quickJournalNightShipDrift___hF5pa`,
	"shipTwo": `QuickJournalNightLakeShips__shipTwo___w8GDC`,
	"shipThree": `QuickJournalNightLakeShips__shipThree___UEyHM`,
	"shipInner": `QuickJournalNightLakeShips__shipInner____PrCD`,
	"quickJournalNightShipBob": `QuickJournalNightLakeShips__quickJournalNightShipBob___Gi9pD`,
	"hull": `QuickJournalNightLakeShips__hull___xQwJ7`,
	"cabin": `QuickJournalNightLakeShips__cabin___wAPDF`,
	"light": `QuickJournalNightLakeShips__light___cZVj5`,
	"lightOne": `QuickJournalNightLakeShips__lightOne___FGQim`,
	"lightTwo": `QuickJournalNightLakeShips__lightTwo___arYmD`,
	"lightThree": `QuickJournalNightLakeShips__lightThree___U54zL`,
	"reflection": `QuickJournalNightLakeShips__reflection___wEah8`
};
module.exports = ___CSS_LOADER_EXPORT___;
